import {Link} from "react-router-dom";

const Index = (props) =>
{
    const handleChange = (e) => 
    {
        props.handleChange();
    } 

    return (
                <div className="top-24 overflow-y-hidden fixed lg:absolute top-0 bottom-0 left-0 lg:pt-0 legal-container flex items-start lg:items-center justify-center w-screen filter blur-0 h-full lg:h-screen" style={{zIndex: "99"}}>
                    <div className="overflow-y-hidden" style={{boxShadow: '10px 10px 0px 0px rgb(0 0 0 / 35%), 2px -1px 13px 8px rgb(0 0 0 / 0%)'}}>
                        <div className="w-4/4 flex flex-wrap lg:flex-nowrap bg-blue-light mx-auto items-stretch" style={{maxWidth:"1200px"}}>
                            <div className="bar-height w-full lg:w-12 bg-blue-primary flex-shrink-0"></div>
                            <div className="flex-grow px-4 py-8">
                                <p className="text-gray-text text-center text-sm lg:text-base mb-6">
                                    By continuing in this section, you acknowledge that you are a Healthcare Professional.  
                                </p>
                                <div className="flex items-center justify-center space-x-4">
                                    <Link to="/" className="transition bg-white text-gray-text select-none block text-center focus:outline-none text-xs 2xl:text-sm uppercase border-1 border-gray-light py-1 px-2 xl:py-2 xl:px-4 text-white font-light">
                                        Decline
                                    </Link>
                                    <div  className="transition bg-white cursor-pointer text-gray-text select-none block text-center focus:outline-none text-xs 2xl:text-sm uppercase border-1 border-gray-light py-1 px-2 xl:py-2 xl:px-4 text-white font-light" onClick={handleChange}>
                                        Continue
                                    </div>
                                </div>
                            </div>
                            <div className="bar-height  w-full lg:w-12 bg-red-primary flex-shrink-0"></div>
                        </div>
                    </div>
                </div>
    )
}

export default Index;